import i18n from "@i18n";

export const fileViewModes: any = {
  DETAILED_VIEW: "DETAILED_VIEW",
  LARGE_ICONS_VIEW: "LARGE_ICONS_VIEW",
};
export const fileViewIconsMapper: any = {
  DETAILED_VIEW: "ListViewIcon",
  LARGE_ICONS_VIEW: "GridViewIcon",
};
export const fileViewOptions: any = [
  { text: i18n.t("Details"), id: fileViewModes.DETAILED_VIEW },
  { text: i18n.t("Large Icons"), id: fileViewModes.LARGE_ICONS_VIEW },
];
